// ============================================================
// はじめてのセルフ利用ガイド（承認済みモック self-guide の移植）
// 自分の拠点（lpspot）に応じてロッカー手順/店頭手順を出し分ける。
// 10/1料金改定で3km超の顧客がセルフ対応へ移行するための事前ガイド。
// ============================================================
import { IoChevronBack } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { TailSpin } from 'react-loading-icons';
import { Analytics } from '../../compornents/Analytics';
import { useSelfSpotInfo, spotSelfType, spotAddress, TP_MENU_IMG, navUrl } from './selfGuideData';
import '../../css/SelfGuide.css';

export const SelfGuide = () => {
  const navigate = useNavigate();
  const { lpspot, gcompany, loading } = useSelfSpotInfo();
  const back = () => navigate(-1);

  const type = spotSelfType(lpspot);
  const isLocker = type === 'locker';
  const hoursTxt = [lpspot?.business_hours, lpspot?.holiday].filter(Boolean).join('\n');

  return (
    <div className="App">
      <div className="SelfGuide">
        <Analytics title="はじめてのセルフ利用" />
        <div className="toolbar mb-3">
          <div className="toolbar_left div_btn" onClick={back}>
            <IoChevronBack />
          </div>
          <div className="toolbar_center">
            はじめてのセルフ利用
          </div>
          <div className="toolbar_right">
          </div>
        </div>
        {loading ? (
          <div className="sg-loading"><TailSpin stroke="#000" /></div>
        ) : (
          <div className="sg-body">
            <div className="sg-title">
              {type === 'none' ? <>セルフ対応は<br />準備中です</> : isLocker ? <>ロッカーは<br />かんたん・24時間・無料</> : <>店頭でのお預けは<br />かんたん・無料</>}
            </div>
            {lpspot && type !== 'none' && (
              <div className="sg-note">
                <b>{lpspot.name}</b>{gcompany?.name ? <>（担当：{gcompany.name}）</> : null}をご利用のお客様向けのご案内です。配達手数料はかかりません。
              </div>
            )}

            {type === 'none' ? (
              // セルフ未対応拠点（海神クリーニング 瑞江・船堀）は今回リリース対象外(2026-09-01決定)。
              // 手順・ナビ・写真は出さず、簡潔なフォールバックのみ表示する。
              <div className="sg-callout">
                お客様の担当拠点では、セルフでのお預け・お受け取りの準備中です。準備が整いましたら、アプリのお知らせでご案内いたします。
              </div>
            ) : (
              <>
                <div className="sg-todo">
                  <div className="sg-tt">{isLocker ? 'お預けの流れ（3分ほど）' : '店頭でのお預けの流れ'}</div>

                  <div className="sg-stp">
                    <span className="sg-n">1</span>
                    <span className="sg-tx">
                      アプリで注文し、受け渡し方法で<b>{isLocker ? '「自分でロッカーに預ける」' : '「自分で店舗に持っていく」'}</b>を選ぶ
                    </span>
                  </div>

                  <div className="sg-stp">
                    <span className="sg-n">2</span>
                    <span className="sg-tx">
                      {isLocker ? 'ロッカーへ行く' : <><b>営業時間内</b>に店舗へ行く</>}
                      {hoursTxt && <><br /><small>{hoursTxt}</small></>}
                    </span>
                  </div>
                  {(isLocker ? lpspot?.locker_image : lpspot?.spot_image) && (
                    <>
                      <img
                        src={isLocker ? lpspot.locker_image : lpspot.spot_image}
                        alt={isLocker ? 'ロッカーの場所' : '店舗の外観'}
                        className="sg-img"
                      />
                      <div className="sg-cap">▲ {lpspot.name}（{spotAddress(lpspot)}）</div>
                    </>
                  )}
                  {/* ワンタップで現在地からの徒歩ナビを起動（本体v1.10.12のナビボタンと同仕様） */}
                  {lpspot?.lat && (
                    <a
                      href={navUrl(lpspot.lat, lpspot.lon)}
                      target="_blank" rel="noreferrer"
                      className="btn btn-sm btn-oval btn-black w-100 mb-2"
                      style={{ color: '#fff', textDecoration: 'none' }}
                    >
                      🧭 {isLocker ? 'ロッカー' : '店舗'}までナビを開始（Googleマップ）
                    </a>
                  )}

                  {isLocker ? (
                    <>
                      <div className="sg-stp">
                        <span className="sg-n">3</span>
                        <span className="sg-tx">タッチパネルの<b>「お客様」</b>をタッチ</span>
                      </div>
                      <img src={TP_MENU_IMG} alt="タッチパネルの最初の画面" className="sg-img sg-img-frame" />
                      <div className="sg-cap">▲ 最初の画面。<b>「お客様」</b>をタッチ（もう一方はUber配達員様用です）</div>

                      <div className="sg-stp">
                        <span className="sg-n">4</span>
                        <span className="sg-tx">アプリに表示される<b>ロッカー開錠コード（5桁）</b>を入力して <b>ENTER</b></span>
                      </div>
                      <div className="sg-tp">
                        <div className="sg-tp-bar"><span className="sg-back">← 戻る</span></div>
                        <div className="sg-tp-title">ロッカー解錠コードを入力してください</div>
                        <div className="sg-tp-code">K 7 M _ _</div>
                        <div className="sg-tp-keys">
                          <span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span><span>8</span><span>9</span><span>0</span>
                          <span>Q</span><span>W</span><span>E</span><span>R</span><span>T</span><span>Y</span><span>U</span><span>I</span><span>O</span><span>P</span>
                          <span>A</span><span>S</span><span>D</span><span>F</span><span>G</span><span>H</span><span>J</span><span>K</span><span>L</span><span className="sg-cl">クリア</span>
                          <span>Z</span><span>X</span><span>C</span><span>V</span><span>B</span><span>N</span><span>M</span><span className="sg-en">ENTER</span>
                        </div>
                      </div>
                      <div className="sg-cap">▲ アプリの注文画面に出ている<b>英数字5桁</b>を入力し、<b>ENTER</b></div>

                      <div className="sg-stp">
                        <span className="sg-n">5</span>
                        <span className="sg-tx">
                          扉が開いたら、お品物を入れて扉を閉め、画面の<b>「完了」</b>をタッチ<br />
                          <small>バッグに入れなくてもそのままで大丈夫です</small>
                        </span>
                      </div>
                      <div className="sg-tp">
                        <div className="sg-tp-msg">扉が開きました</div>
                        <div className="sg-tp-sub">BOX 020 のロッカーにお品物を入れて、扉を閉めてください</div>
                        <span className="sg-tp-done">完了</span>
                      </div>
                      <div className="sg-cap">▲ 開いたロッカーの番号が表示されます</div>

                      <div className="sg-stp">
                        <span className="sg-n">6</span>
                        <span className="sg-tx">アプリの<b>「お預け完了」</b>ボタンを押す <span className="sg-ng">← 忘れずに</span></span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="sg-stp">
                        <span className="sg-n">3</span>
                        <span className="sg-tx">店頭で<b>注文番号</b>をお伝えください（アプリの注文画面に表示されます）</span>
                      </div>
                      <div className="sg-stp">
                        <span className="sg-n">4</span>
                        <span className="sg-tx">アプリの<b>「お預け完了」</b>ボタンを押す <span className="sg-ng">← 忘れずに</span></span>
                      </div>
                      <div className="sg-callout">
                        <b>ご注意</b>
                        ロッカーと違い、営業時間外・定休日にはお預け・お受け取りができません{hoursTxt && <>（{hoursTxt.replace(/\n/g, '・')}）</>}。
                      </div>
                    </>
                  )}
                </div>

                <div className="sg-callout">
                  <b>お受け取りも同じ流れです</b>
                  仕上がるとお知らせが届きます。{isLocker ? <><b>お預けいただいたロッカー</b>で同じようにコードを入力して受け取り</> : <><b>営業時間内に店頭</b>で受け取り</>}、アプリの「お受け取り完了」を押してください。<b>セルフでお受け取りいただくと300円クーポンをプレゼント。</b>
                </div>
              </>
            )}

            {gcompany && type !== 'none' && (
              <div className="sg-callout">
                <b>お困りのときは</b>
                担当クリーニング店：<b>{gcompany.name}</b>
                {gcompany.contact && <><br />TEL <b>{gcompany.contact}</b>（営業時間内）</>}
              </div>
            )}

            {type !== 'none' && (
              <>
                <Link to="/self_guide/faq" className="sg-btn-next">よくあるご質問を見る</Link>
                <Link to="/self_spots" className="sg-btn-ghost">セルフ対応できる拠点の一覧を見る</Link>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
